/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import {
  EuiButton,
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiPopoverFooter,
  EuiPopoverTitle,
  EuiText,
  useEuiTheme,
} from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

// eslint-disable-next-line import/no-restricted-paths
import { createOrganizationUrl, manageUserOrganizationsUrl } from '@/apps/userconsole/urls'

import OrganizationSwitchList from '../OrganizationSwitchList'

import { messages } from './messages'

const OrganizationPopover = ({ closePopover }: { closePopover: () => void }) => {
  const { euiTheme } = useEuiTheme()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <EuiPopoverTitle paddingSize='m' style={{ height: euiTheme.size.xxxxl }}>
        <EuiFlexGroup
          justifyContent='spaceBetween'
          alignItems='center'
          style={{ height: euiTheme.size.xl }}
        >
          <EuiText size='m' style={{ fontWeight: euiTheme.font.weight.semiBold }}>
            <FormattedMessage {...messages.title} />
          </EuiText>
          <EuiButtonEmpty
            iconType='plusCircle'
            aria-label={formatMessage(messages.createOrganizationAriaLabel)}
            onClick={() => navigate(createOrganizationUrl())}
          >
            <FormattedMessage {...messages.createOrganization} />
          </EuiButtonEmpty>
        </EuiFlexGroup>
      </EuiPopoverTitle>
      <OrganizationSwitchList listStyle={{ width: '324px' }} />
      <EuiPopoverFooter paddingSize='m'>
        <EuiButton
          fullWidth={true}
          color='text'
          onClick={() => {
            navigate(manageUserOrganizationsUrl())
            closePopover()
          }}
        >
          <FormattedMessage
            id='organization-switch.manage-organizations-button'
            defaultMessage='Manage organizations'
          />
        </EuiButton>
      </EuiPopoverFooter>
    </React.Fragment>
  )
}

export default OrganizationPopover
